// extracted by mini-css-extract-plugin
var _1 = "CallOut-module__callOut--ty5tH";
var _2 = "CallOut-module__danger--cgF2G";
var _3 = "CallOut-module__info--IW0fM";
var _4 = "CallOut-module__success--pEeU6";
var _5 = "CallOut-module__warning--J4tO4";
export { _1 as "callOut", _2 as "danger", _3 as "info", _4 as "success", _5 as "warning" }
